import { manufacturingFetch } from "@/lib/manufacturingClient";
import type {
  MfgBuildPipelinePhaseCreateResponse,
  MfgBuildPipelinePhaseDeleteResponse,
  MfgBuildPipelinePhasesListResponse,
  MfgBuildPipelinePhasesResequenceResponse,
  MfgBuildPipelinePhaseUpdateResponse,
  MfgBuildPipelineTransitionResponse,
} from "@/lib/manufacturing/buildPipelineTypes";

export function listManufacturingBuildPipelinePhases() {
  return manufacturingFetch<MfgBuildPipelinePhasesListResponse>(
    "/api/mfg/build-pipeline/phases",
    { method: "GET" }
  );
}

export function createManufacturingBuildPipelinePhase(payload: {
  phase_key?: string;
  display_name: string;
  sequence_index?: number;
  is_initial?: boolean;
  is_build_complete?: boolean;
  is_pay_trigger?: boolean;
  sub_role_tag?: string;
}) {
  return manufacturingFetch<MfgBuildPipelinePhaseCreateResponse>(
    "/api/mfg/build-pipeline/phases/create",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function updateManufacturingBuildPipelinePhase(payload: {
  phase_id: string;
  display_name?: string;
  sequence_index?: number;
  is_initial?: boolean;
  is_build_complete?: boolean;
  is_pay_trigger?: boolean;
  sub_role_tag?: string;
}) {
  return manufacturingFetch<MfgBuildPipelinePhaseUpdateResponse>(
    "/api/mfg/build-pipeline/phases/update",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function deleteManufacturingBuildPipelinePhase(payload: { phase_id: string }) {
  return manufacturingFetch<MfgBuildPipelinePhaseDeleteResponse>(
    "/api/mfg/build-pipeline/phases/delete",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function resequenceManufacturingBuildPipelinePhases(payload: { phase_ids: string[] }) {
  return manufacturingFetch<MfgBuildPipelinePhasesResequenceResponse>(
    "/api/mfg/build-pipeline/phases/resequence",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function transitionManufacturingUnitPhase(payload: {
  unit_id: string;
  to_phase_id: string;
  notes?: string;
}) {
  return manufacturingFetch<MfgBuildPipelineTransitionResponse>(
    "/api/mfg/build-pipeline/transition",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}
